module.exports = "fonts/GilroyRegular.woff2";